export default __webpack_public_path__ + "static/media/403.03d1943a.png";